import { Layout, LayoutContainer, Page } from "@fdoh/health-ui-react";
import { DataTable, Select2 } from "@fdoh/health-react";
import { useEffect, useRef, useState } from "react";
import {Link, useHistory,  useLocation } from "react-router-dom";
import useData from "../../hooks/useData";
import useClient from "../../hooks/useInspectionClient";
import { Row } from "@fdoh/health-react";



export type CountyEmailData = {
  key: string;
  value: string;
};

const Columns = [
  {
      Header: "County Name",
      accessor: (row: CountyEmailData) => row.key,
      
  },
  {
      Header: "County Email",
      Cell: ({ row }: { row: { original: CountyEmailData } }) => (
        <a href={`mailto:${row.original.value}`}>{row.original.value}</a>
      ),
      //accessor: (row: CountyEmailData) => row.value, 
  },
]

export const SupportRequestPage = () => {
  const { search } = useLocation();
  const client = useClient();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
    const [countyEmailData, setCountyEmailData] = useState<CountyEmailData[]>([]);

    let countyEmails= useData<CountyEmailData[]>('county/GetEmailByCountyId' );
    let Recentlyopened = countyEmails?.filter(x => x.key == "1");
    
    return (
      <Page.Container>
         <div>

<div className="card-body text-center">
 
  <p>Please be aware that user, technical, and programmatic support will be available during regular business hours, generally Monday through Friday, 8 am to 5 pm (eastern time).  All issues and requests will be handled as soon as possible during these business hours.</p>
  <p>For all questions, please contact <a href="mailto:OSP-help@floridadep.gov">OSP-help@floridadep.gov</a></p>

 
  <div>

  </div>
</div>
</div>
  </Page.Container>
    ); <div>
    
  </div>;
};

export default SupportRequestPage;